import { FormattedMessage } from 'react-intl';
import appMessages from '../containers/App/messages';
export const YES_NO_OPTIONS = [
  { value: 'yes', text: <FormattedMessage {...appMessages.yes} /> },
  { value: 'no', text: <FormattedMessage {...appMessages.no} /> },
];
